import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { FetchBoards } from '..';

export function useBoards() {
  const { workspaceId } = useWorkspaceId();
  const queryKeys = useQueryKeys();

  return useQuery({
    queryKey: queryKeys.board.lists(),
    queryFn: ({ signal }) => FetchBoards(workspaceId, signal),
    staleTime: 30_000,
  });
}
